import { AuthorizeNetCreditCard } from '../models/authorizenet-credit-card';
import { AuthorizeNetProfile } from '../models/authorizenet-profile';
import { CARD_TYPE, CardType } from '../models/card-type';
import { PaymentProfile } from '../models/payment-profile';

const MAP_CARD_TYPE_FROM_DTO = {
  Visa: CARD_TYPE.Visa,
  MasterCard: CARD_TYPE.MasterCard,
  AmericanExpress: CARD_TYPE.AmEx,
  Discover: CARD_TYPE.Discover,
};

/**
 * Map authorizenet card type from dto.
 * @param {string} dto Dto.
 * @returns {CardType}
 */
function cardTypeFromDto(dto) {
  return MAP_CARD_TYPE_FROM_DTO[dto];
}

/**
 * Map authorizenet credit card from dto.
 * @param {object} dto Dto.
 * @returns {AuthorizeNetCreditCard}
 */
function authorizeNetCreditCardFromDto(dto) {
  return new AuthorizeNetCreditCard({
    cardNumber: dto.cardNumber,
    expirationDate: dto.expirationDate,
    issuerNumber: dto.issuerNumber,
    cardType: cardTypeFromDto(dto.cardType) ?? null,

    // Get 1234 from XXXX1234
    lastFourNumbers: dto.cardNumber.slice(-4),
  });
}

/**
 * Map authorizenet payment profile from dto.
 * @param {object} dto Dto.
 * @returns {PaymentProfile}
 */
function paymentProfileFromDto(dto) {
  return new PaymentProfile({
    customerPaymentProfileId: dto.customerPaymentProfileId,

    // The dto can be undefined
    isDefaultPaymentProfile: Boolean(dto.defaultPaymentProfile),

    payment: {
      creditCard: authorizeNetCreditCardFromDto(dto.payment.creditCard),
    },

    billTo: {
      address: dto.billTo.address,
      city: dto.billTo.city,
      company: dto.billTo.company,
      firstName: dto.billTo.firstName,
      lastName: dto.billTo.lastName,
      phoneNumber: dto.billTo.phoneNumber,
      state: dto.billTo.state,
      zip: dto.billTo.zip,
    },
  });
}

/**
 * Map authorizenet profile from dto.
 * @param {object} dto Dto.
 * @returns {AuthorizeNetProfile}
 */
function authorizeNetProfileFromDto(dto) {
  return new AuthorizeNetProfile({
    description: dto.description,
    customerProfileId: dto.customerProfileId,
    paymentProfiles: dto.paymentProfiles ? dto.paymentProfiles.map(profile => paymentProfileFromDto(profile)) : [],
  });
}

export const creditCardMapper = {
  authorizeNetProfileFromDto,
};
